import { render, staticRenderFns } from "./ProductByCFUCards.vue?vue&type=template&id=a7e1a96c&"
import script from "./ProductByCFUCards.vue?vue&type=script&lang=js&"
export * from "./ProductByCFUCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports